import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';
import { getNeoCashOutFinalCashAmount, INeoCashOutVoucherDetails } from '@lib/interfaces/card-less.interface';

@Component({
    selector: 'app-approve-confirm-modal',
    standalone: true,
    templateUrl: './approve-confirm-modal.component.html',
    styleUrls: ['./approve-confirm-modal.component.scss'],
    imports: [AngularMaterialModule],
})
export class ApproveConfirmModalComponent {
    constructor(private readonly dialogRef: MatDialogRef<ApproveConfirmModalComponent, boolean>, @Inject(MAT_DIALOG_DATA) protected readonly data: { voucherDetails: INeoCashOutVoucherDetails }) {}

    protected get finalCashAmount(): number {
        return getNeoCashOutFinalCashAmount(this.data.voucherDetails);
    }

    protected back(): void {
        this.dialogRef.close(false);
    }

    protected approve(): void {
        this.dialogRef.close(true);
    }
}
